// AccountDetails.tsx
import React from 'react';
import { useForm } from 'react-hook-form';
import { useAuthStore } from '@/store/authStore';
import { Button } from '@/components/common/Button';
import { Input } from '@/components/common/Input';

export const AccountDetails: React.FC = () => {
  const { user, updateProfile } = useAuthStore();
  const { register, handleSubmit, formState: { errors } } = useForm({
    defaultValues: {
      fullName: user?.name || '',
      email: user?.email || '',
    }
  });

  const onSubmit = async (data: any) => {
    await updateProfile({ name: data.fullName });
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-3">
      <h2 className="text-xl font-medium text-gray-900 mb-8">Account Details</h2>
      
      <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
        <div className="grid grid-cols-2 gap-6">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Full Name
            </label>
            <Input
              {...register('fullName', { required: 'Full name is required' })}
              error={errors.fullName?.message}
              className="w-full"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Email Address
            </label>
            <Input
              type="email"
              {...register('email')}
              disabled
              className="w-full bg-gray-50"
            />
          </div>
        </div>

        <div className="flex justify-end pt-4">
          <Button type="submit" variant="primary">
            Save Changes
          </Button>
        </div>
      </form>
    </div>
  );
};